import React from "react";
import './Logo.scss';

function Logo({isClassicMode}) {
  const logoURL = process.env.PUBLIC_URL + `./assets/logo/${isClassicMode ? 'logo' : 'logo_deluxe'}.png?${Date.now()}`;

  return <div className={`logo ${isClassicMode ? 'classic' : 'deluxe'}`}>
    <img src={logoURL} alt="stw-logo"/>
  </div>
}

export default Logo;
